// 中文繁體
export default {
  title:{
      homeTitle:'慧悅財經企業官網',
      aboutTitle:'關於慧悅',
      servicesTitle:'我們的服務',
      joinUSTitle:'加入我們',
      concatUSTitle:'聯繫我們',
      newsTitle:'慧悅資訊圈',
    },
    narBar:{
      1:'關於慧悅',
      2:'我們的服務',
      3:'慧悅資訊圈',
      4:'聯繫我們',
      5:'加入我們',
    },
    home:{
      1:'慧悅財經',
      2:'專注於香港與內地金融市場互聯互通',
      3:'致力搭建中港兩地企業與投資者溝通橋樑',
      4:'我們的服務',
      5:'慧悅財經-諮詢',
      6:'專業投研團隊分析及推廣香港企業',
      7:'資深團隊全方位提供財經策略諮詢',
      8:'香港最熱門港股在線教育平台',
      9:'為投資者保駕護航',
      10:'學習課程',
      11:'港股交易日直播',
      12:'瞭解更多',
      13:'慧悅團隊每日股票市場分析',
      14:'慧悅財經5分鐘懂盤前獨家資訊',
      15:'善用強大媒體網絡',
      16:'滲透不同平台渠道',
      17:'雲集精英團隊',
      18:'深厚金融投研經驗成員',
      19:'資深港美股操盤手',
      20:'強大技術運營團隊',
      21:'關於慧悅',
      22:'今日直播',
      23:'今日資訊',
      24:'微早報',
    },
    homeItem:{
      1:'關於慧悅',
      2:'我們的服務',
      3:'慧悅資訊圈',
      4:'聯繫我們',
      5:'加入我們',
      6:'慧悅財經'
    },
    about:{
      1:'關於我們',
      2:'隨著中港兩地金融市場互聯互通進一步加深，兩地資本市場都迎來歷史性機遇。港股市場成為內地投資者關注的焦點，內地市場對港股教育的需求殷切，慧悅財經公共關係顧問集團有限公司應運而生，並因其特有的強大媒體合作網絡、自家研究團隊和行業前瞻性，為香港企業得以高效便捷發佈資訊，與內地投資者互動溝通。',
      3:'微訊公眾號',
      4:'慧悅資訊平台',
      5:'1.慧悅財經官方網站',
      6:'2.慧悅財經微信公眾號',
      7:'3.慧悅財經應用程式',
      8:'4.新浪微博-財經主持VIVIAN',
    },
    services:{
      1:'財經顧問',
      2:'慧悅財經為客戶提供專業財經顧問服務，為客戶度身訂造宣傳計劃，幫助企業在市場建立品牌，提升公司商譽。團隊擁有豐富經驗，清晰明確瞭解股票市場需求，精準地將訊息傳播給受眾，提供精闢意見協助企業提高在國內市場的認知度。慧悅的顧問服務內容包括：',
      3:'企業形象包裝',
      4:'分析性文章及新聞稿撰寫',
      5:'企業活動統籌',
      6:'媒體危機處理',
      7:'投資者關係維護',
      8:'企業宣傳材料設計及製作',
      9:'慧悅線上教育課程',
      10:'慧悅財經提供線上教育課程，教育投資者瞭解證券資本市場投資竅門，增進投資知識。與慧悅財經合作的老師皆為市場上馳名的證券分析專家，深入淺出地向中港兩地投資者解釋投資心法，讓投資者能在短時間內掌握實用的投資技巧。課程涵蓋香港證券市場主要投資工具，包括大價股、中小價股、期權、交易所買賣基金等等，滿足香港不同的投資者的學習需要。',
      11:'與慧悅合作的主打老師包括：',
      12:'豐盛金融資產管理董事—黃國英',
      13:'皓豐投資商學院創辦人—朱晉民',
      15:'著名香港股市分析師—沈振盈',
      16:'三星資產運用(香港)有限公司ETF銷售總管—蕭曉婷',
      17:'興證國際證券客戶投資組副總裁—盧駿匡',
      18:'90後上市公司執行董事，專業投資者—渾水',
      19:'獨立股評人，財經專欄作家—捕風',
      20:'現任對沖基金程式交易量化分析師—蔡嘉民',
      21:'著名香港股市分析師—魏力',
      22:'阿布扎比證券香港有限公司的零售市場銷售總監—陳健豪',
    },
    news:{
      1:'股市直播',
      2:'慧悅財經每日都會進行兩場一小時的直播，分為廣東話和普通話時段。',
      3:'邀請市場上著名股票分析專家作為嘉賓，與投資者一起分析大市走勢，實時分享投資策略。慧悅財經直播的平台遍佈中港兩地，包攬華人地區大部分觀眾群，確保直播資訊能最快、最廣泛地接觸受眾。觀眾亦可以在直播期間在直播平台對嘉賓提問，解答投資疑難，增加投資準確度。',
      4:'廣東話直播時段：下午13:30分至14:30分；',
      5:'直播頻道：Facebook、Youtube；',
      6:'普通話直播時段：下午16:30分至17:30分；',
      7:'直播頻道：富途牛牛、騰訊自選股、新浪一直播、捷利交易寶；',
      8:'今日資訊',
      9:'慧悅財經的專業財經市場分析團隊每天早上都會整理「今日資訊」，總結前個交易天的大市概況、重點財經新聞、環球經濟動態， 讓投資者可以對當前財經局勢有充分的理解，更容易掌握市場脈搏，投資時能更得心應手。',
      10:'微早報',
      11:'慧悅財經5分鐘懂盤前獨家資訊',
      12:'IOS下載',
      13:'ANDROID下載',
    },
    concatUS:{
      1:'香港總部：',
      2: '地址: 香港上環永樂街5號永安祥大廈6樓',
      3:'電話: (+852)3618 8460',
      4:'電郵: info@intelligentjoy.com',
      5:'深圳辦公室：',
      6:'地址: 深圳市南山區高新南七道風華科技大廈2樓206-209室',
      7:'電話: (+86)0755 26718880',
      8:'電郵: it@intelligentjoy.com',
    },
    joinUS:{
      1:'加入我們',
      2:'如有意加入慧悅財經團隊，請把詳盡個人履歷及期望薪酬發送至人力資源部: info@intelligentjoy.com',
    }
}



// WEBPACK FOOTER //
// ./src/i18n/lang/zh_tw.js